import type {
  AnalyticsDetailedContentTypes,
  LocaleMessages
} from 'shared-types';
import type { IconProp } from 'components/common/icons/Icon';

interface Params {
  messages: LocaleMessages;
}

// the order of the types is important, it will be used to determine the
// order displayed for the user selection in the /analytics/detailed page
const getSupportedDetailedTypes = ({ messages }: Params) =>
  ({
    courses: {
      icon: 'book',
      id: 'courses',
      labels: {
        buttonText: messages.commonCourses,
        filterText: messages.analyticsDetailedAnalyticsSelectCourses
      }
    },
    paths: {
      icon: 'tasks',
      id: 'paths',
      labels: {
        buttonText: messages.commonPaths,
        filterText: messages.analyticsDetailedAnalyticsSelectPaths
      }
    },
    achievements: {
      icon: 'check-circle',
      id: 'achievements',
      labels: {
        buttonText: messages.commonAchievements,
        filterText: messages.analyticsDetailedAnalyticsSelectAchievements
      }
    },
    calendarEvents: {
      icon: ['far', 'calendar-days'],
      id: 'calendar-events',
      labels: {
        buttonText: messages.commonCalendarEvents,
        filterText: messages.analyticsDetailedAnalyticsSelectCalendarEvents
      }
    },
    competencies: {
      icon: 'medal',
      id: 'competencies',
      labels: {
        buttonText: messages.analyticsCompetencies,
        filterText: messages.analyticsDetailedAnalyticsSelectCompetencies
      }
    }
  } as Record<
    AnalyticsDetailedContentTypes,
    {
      icon: IconProp;
      id: string;
      labels: {
        buttonText: string;
        filterText: string;
      };
    }
  >);

export default getSupportedDetailedTypes;
